import { Box, Button, Stack, TextField } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DialogPlanLlmPrompt } from '../../api/DialogPlanLlmPromptApi';
import { DialogPromptTypeSpeak } from '../../api/DialogPromptApi';
import AppBarContext from '../../context/AppBarContext';
import { useSentenceChinesePinyin } from '../../hook/useSentenceChinesePinyin';
import { useStudentResponsePinyin } from '../../hook/useStudentResponsePinyin';

interface DialogPlanLlmPromptTypeSpeakGeneratedProps {
    dialogPrompt?: DialogPromptTypeSpeak; // if llmPrompt was generated
    onSubmit?: (updatedDialogPlanLlmPrompt: DialogPlanLlmPrompt, setIsSaving: React.Dispatch<React.SetStateAction<boolean>>) => void;
    onDelete?: (dialogPlanLlmPromptId: number) => void;

    isRegenerating?: boolean;
    handleLlmPromptChange?: (dialogPlanLlmPrompt: DialogPlanLlmPrompt) => void;
    handleRegenerateDialogPlanLlmPrompt?: (dialogPlanLlmPrompt: DialogPlanLlmPrompt, fieldName: string) => void;
}

const DialogPlanLlmPromptTypeSpeakGenerated: React.FC<DialogPlanLlmPromptTypeSpeakGeneratedProps> = ({ dialogPrompt }) => {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    // const [teacherChinesePrompt, setTeacherChinesePrompt] = React.useState("");
    const {
        text: teacherChinesePrompt,
        pinyin: teacherChinesePromptPinyin,
        pinyinList: teacherChinesePromptPinyinList,
        pinyinErrorText: teacherChinesePromptPinyinErrorText,
        setDialogPromptFields: setTeacherChinesePromptields,
        clearErrorText: clearTeacherChinesePromptErrorText,
        handleTextChange: handleTeacherChinesePromptChange,
        handlePinyinChange: handleTeacherChinesePromptPinyinChange,
    } = useSentenceChinesePinyin({ history, location, setErrorMessage });

    // const [studentResponsePrompt, setStudentResponsePrompt] = React.useState("<Answer/>");
    // const [studentResponseList, setStudentResponseList] = React.useState("");
    const {
        studentResponsePrompt,
        studentResponseList,
        studentResponseListErrorText,
        studentResponsePinyinList,
        studentResponsePinyinErrorText,
        setStudentResponseFields,
        clearStudentResponseErrors,
        handleStudentResponsePromptChange,
        handleStudentResponseListChange,
        handleStudentResponsePinyinListChange,
    } = useStudentResponsePinyin({ history, location, setErrorMessage });

    const [teacherAskStudentToSpeakPrompt, setTeacherAskStudentToSpeakPrompt] = React.useState("");
    const [spokenYesResponse, setSpokenYesResponse] = React.useState("");
    const [spokenNoResponse, setSpokenNoResponse] = React.useState("");

    const setDialogPromptFields = React.useCallback((dialogPrompt: DialogPromptTypeSpeak) => {
        // setTeacherChinesePrompt(dialogPrompt.teacher_chinese_prompt ? dialogPrompt.teacher_chinese_prompt : "")
        setTeacherChinesePromptields(dialogPrompt.teacher_chinese_prompt, dialogPrompt.teacher_chinese_prompt_pinyin, dialogPrompt.teacher_chinese_prompt_sentence_id)
        setStudentResponseFields(dialogPrompt.student_response_prompt, dialogPrompt.dialog_prompt_sentence_list)
        // setStudentResponsePrompt(dialogPrompt.student_response_prompt ? dialogPrompt.student_response_prompt : "")
        // setStudentResponseList(dialogPrompt.dialog_prompt_sentence_list
        //     ? dialogPrompt.dialog_prompt_sentence_list
        //         .map(item => item.student_response)
        //         .join("\n") // Convert array to newline-separated string
        //     : ""
        // )
        setTeacherAskStudentToSpeakPrompt(dialogPrompt.teacher_ask_student_to_speak_prompt ? dialogPrompt.teacher_ask_student_to_speak_prompt : "")
        setSpokenYesResponse(dialogPrompt.spoken_yes_response ? dialogPrompt.spoken_yes_response : "")
        setSpokenNoResponse(dialogPrompt.spoken_no_response ? dialogPrompt.spoken_no_response : "")
    }, [setTeacherChinesePromptields, setStudentResponseFields, setTeacherAskStudentToSpeakPrompt, setSpokenYesResponse, setSpokenNoResponse])

    React.useEffect(() => {
        if (dialogPrompt) {
            setDialogPromptFields(dialogPrompt);
            clearTeacherChinesePromptErrorText();
            clearStudentResponseErrors()
        }
    }, [clearStudentResponseErrors, clearTeacherChinesePromptErrorText, dialogPrompt, setDialogPromptFields])

    React.useEffect(() => {
        if (dialogPrompt) dialogPrompt.teacher_chinese_prompt = teacherChinesePrompt;
    }, [teacherChinesePrompt, dialogPrompt])

    React.useEffect(() => {
        if (dialogPrompt) dialogPrompt.teacher_chinese_prompt_pinyin = teacherChinesePromptPinyinList;
    }, [teacherChinesePromptPinyinList, dialogPrompt])


    // update dialog prompt
    // const handleTeacherChinesePromptChange = (e: React.ChangeEvent<HTMLInputElement>) => { setTeacherChinesePrompt(e.target.value); if (dialogPrompt) dialogPrompt.teacher_chinese_prompt = e.target.value };
    // const handleStudentResponsePromptChange = (e: React.ChangeEvent<HTMLInputElement>) => { setStudentResponsePrompt(e.target.value); if (dialogPrompt) dialogPrompt.student_response_prompt = e.target.value };
    // const handleStudentResponseListChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const responseListString = e.target.value
    //     setStudentResponseList(responseListString);
    //     if (dialogPrompt) {
    //         const lines = responseListString.split("\n").filter(line => line.trim() !== "");

    //         // Map each line to an IDialogPromptSentence object
    //         dialogPrompt.dialog_prompt_sentence_list = lines.map((studentResponse, index) => ({
    //             id: 0, // Assuming `id` is generated by the backend
    //             dialog_prompt_id: dialogPrompt.id, // Use the provided dialogPromptId
    //             sentence_id: 0, // Assuming this is set later or generated by the backend
    //             student_response: studentResponse.trim(), // Assign the trimmed response
    //             order_index: index + 1, // Incremental order based on line position
    //         }));
    //     }
    // };
    const handleTeacherAskStudentToSpeakPromptChange = (e: React.ChangeEvent<HTMLInputElement>) => { setTeacherAskStudentToSpeakPrompt(e.target.value); if (dialogPrompt) dialogPrompt.teacher_ask_student_to_speak_prompt = e.target.value };
    const handleSpokenYesResponseChange = (e: React.ChangeEvent<HTMLInputElement>) => { setSpokenYesResponse(e.target.value); if (dialogPrompt) dialogPrompt.spoken_yes_response = e.target.value };
    const handleSpokenNoResponseChange = (e: React.ChangeEvent<HTMLInputElement>) => { setSpokenNoResponse(e.target.value); if (dialogPrompt) dialogPrompt.spoken_no_response = e.target.value };

    return (<>
        <Stack spacing={4} sx={{ width: '100%', margin: '0 auto', pt: 2, pb: 4 }}>

            <TextField
                label="Teacher Chinese Prompt"
                value={teacherChinesePrompt}
                onChange={handleTeacherChinesePromptChange}
                multiline
                rows={5}
            />
            <TextField
                label="Teacher Chinese Prompt Pinyin"
                value={teacherChinesePromptPinyin}
                onChange={handleTeacherChinesePromptPinyinChange}
                required
                error={teacherChinesePromptPinyinErrorText != null}
                helperText={teacherChinesePromptPinyinErrorText}
            />
            {/* Hidden spacer button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained"
                    disabled={true}
                    sx={{ opacity: 0 }}
                >
                    Regenerate
                </Button>
            </Box>
            <div>
                <TextField
                    label="Student Chinese Prompt"
                    value={studentResponsePrompt ? studentResponsePrompt : "<Answer/>"}
                    onChange={handleStudentResponsePromptChange}
                    required
                    multiline
                    rows={5}
                    sx={{ width: '100%' }}
                />
                <Typography sx={{ color: 'grey.500', fontSize: '0.9rem' }}>
                    Use &lt;Answer/&gt; to mark where the response is inserted<br />
                    The prompt will be skipped and not displayed, if this field is only &lt;Answer/&gt;
                </Typography>
                {/* Hidden spacer button */}
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button variant="contained"
                        disabled={true}
                        sx={{ opacity: 0 }}
                    >
                        Regenerate
                    </Button>
                </Box>
            </div>
            <TextField
                label="Allowed Student Prompt Responses"
                value={studentResponseList}
                onChange={handleStudentResponseListChange} // just store value on change
                onBlur={handleStudentResponseListChange} // full processing logic goes here
                multiline
                rows={5}
                sx={{ width: '100%' }}
                required
                error={studentResponseListErrorText != null}
                helperText={studentResponseListErrorText}
            />
            <TextField
                label="Allowed Student Prompt Response Pinyin"
                value={studentResponsePinyinList}
                onChange={handleStudentResponsePinyinListChange}
                multiline
                rows={6}
                sx={{ width: '100%' }}
                required
                error={studentResponsePinyinErrorText != null}
                helperText={studentResponsePinyinErrorText}
            />
            {/* Hidden spacer button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained"
                    disabled={true}
                    sx={{ opacity: 0 }}
                >
                    Regenerate
                </Button>
            </Box>
            <TextField
                label="Teacher Ask Student To Speak Prompt"
                value={teacherAskStudentToSpeakPrompt}
                onChange={handleTeacherAskStudentToSpeakPromptChange}
                multiline
                rows={5}
                required
            />
            {/* Hidden spacer button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained"
                    disabled={true}
                    sx={{ opacity: 0 }}
                >
                    Regenerate
                </Button>
            </Box>
            <TextField
                label="Student Spoken Well Prompt"
                value={spokenYesResponse}
                onChange={handleSpokenYesResponseChange}
                multiline
                rows={5}
                required
            />
            {/* Hidden spacer button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained"
                    disabled={true}
                    sx={{ opacity: 0 }}
                >
                    Regenerate
                </Button>
            </Box>
            <TextField
                label="Student Spoken Poorly Prompt"
                value={spokenNoResponse}
                onChange={handleSpokenNoResponseChange}
                multiline
                rows={5}
                required
            />
            {/* Hidden spacer button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained"
                    disabled={true}
                    sx={{ opacity: 0 }}
                >
                    Regenerate
                </Button>
            </Box>
        </Stack>
    </>);
};

export default DialogPlanLlmPromptTypeSpeakGenerated;